import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_SkuComponents = _resolveComponent("SkuComponents");
  const _component_LanguageTiptool = _resolveComponent("LanguageTiptool");
  const _component_DragDialog = _resolveComponent("DragDialog");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "wrap_box bg_white"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "title_box head_box"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          disabled: _ctx.data.isClick,
          onClick: _ctx.clickCom
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("保存")])),
          _: 1,
          __: [5]
        }, 8, ["disabled", "onClick"])]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_SkuComponents, {
      editId: _ctx.data.editSkuId,
      "onUpdate:editId": _cache[0] || (_cache[0] = $event => _ctx.data.editSkuId = $event),
      saveData: _ctx.data.newData,
      "onUpdate:saveData": _cache[1] || (_cache[1] = $event => _ctx.data.newData = $event),
      notice: _ctx.data.noticeSku,
      "onUpdate:notice": _cache[2] || (_cache[2] = $event => _ctx.data.noticeSku = $event),
      onTransmitTableInfo: _ctx.transmitTableInfo
    }, null, 8, ["editId", "saveData", "notice", "onTransmitTableInfo"])]), _createVNode(_component_LanguageTiptool, {
      isShowLanguageTipTool: _ctx.data.isLanguageShow,
      "onUpdate:isShowLanguageTipTool": _cache[3] || (_cache[3] = $event => _ctx.data.isLanguageShow = $event),
      onNoticeShowBatch: _ctx.noticeShowBatch,
      onCloseCurrentPage: _ctx.closeCurrentPage
    }, null, 8, ["isShowLanguageTipTool", "onNoticeShowBatch", "onCloseCurrentPage"]), _ctx.data.dragDialogShow ? (_openBlock(), _createBlock(_component_DragDialog, {
      key: 0,
      isShow: _ctx.data.dragDialogShow,
      "onUpdate:isShow": _cache[4] || (_cache[4] = $event => _ctx.data.dragDialogShow = $event),
      onGetIfClose: _ctx.getIfClose,
      onIsSureClosePage: _ctx.isSureClosePage
    }, null, 8, ["isShow", "onGetIfClose", "onIsSureClosePage"])) : _createCommentVNode("", true)]),
    _: 1
  });
}